import React from "react";
import Card from "components/card";
import { Info } from "lucide-react";
import Button from "components/button";
import { ANNOUNCEMENT_COLOR_OPTIONS } from "../../variables/announcements";

const AnnouncementModal = ({ announcement, onClose }) => {
    const {
        category,
        icon: Icon = Info,
        title,
        dateAnnounced,
        description,
        priority,
        color,
    } = announcement;

    const colorOption = ANNOUNCEMENT_COLOR_OPTIONS.find(
        option => option.label === color
    );

    return (
        <Card className="gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-[500px]">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <div className="flex items-center gap-2 mb-1">
                    <div className="flex items-start gap-3 mb-3">
                        <div className={`p-3 rounded-xl gradient ${colorOption?.gradient}`}>
                            <Icon className="w-6 h-6 text-white" />
                        </div>
                        <div className="flex-1">
                            <h2 className="font-semibold text-[16px]">
                                {title}
                            </h2>
                            <p className="text-sm muted-text">
                                {dateAnnounced}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space-y-4">
                <p className="text-[13px] tracking-normal muted-text">
                    {description}
                </p>
                <div className="p-3 rounded-lg bg-slate-50 border border-slate-200 dark:bg-white/10">
                    <div className="flex items-center gap-2 mb-1">
                        <Info className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                        <span className="text-[12px] font-semibold">
                            Priority Level
                        </span>
                    </div>
                    <p className="text-[11px] capitalize muted-text">
                        {priority}
                    </p>
                </div>
                <Button
                    onClick={onClose}
                    className="access-button btn-got-it text=[12px] w-full"
                >
                    Got it
                </Button>
            </div>
        </Card>
    )
};
export default AnnouncementModal